"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _ = require("./");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    margin-top: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    max-width: ", ";\n    margin-left: auto;\n    margin-right: auto;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    margin-top: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject(), _Constant.Width.MD);

var MainContainer = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var fillContent = _ref.fillContent,
      contentPadding = _ref.contentPadding;
  return fillContent ? '0' : typeof contentPadding === 'number' ? "".concat(contentPadding, "px") : contentPadding;
}, _Constant.Width.SM, function (_ref2) {
  var fillContent = _ref2.fillContent,
      contentMaxWidth = _ref2.contentMaxWidth;
  return fillContent ? '100%' : typeof contentMaxWidth === 'number' ? "".concat(contentMaxWidth, "px") : contentMaxWidth;
});

var MainContent = _styledComponents.default.main(_templateObject3(), _Constant.Width.MD, function (_ref3) {
  var fillContent = _ref3.fillContent;
  return fillContent ? '0' : '25px';
});

var TwoColumnMainContent = function TwoColumnMainContent(_ref4) {
  var menuList = _ref4.menuList,
      cta = _ref4.cta,
      render = _ref4.render,
      phoneNumber = _ref4.phoneNumber,
      isRegistration = _ref4.isRegistration,
      isLogin = _ref4.isLogin,
      linkRoute = _ref4.linkRoute,
      linkText = _ref4.linkText,
      contentMaxWidth = _ref4.contentMaxWidth,
      fillContent = _ref4.fillContent,
      handleRegister = _ref4.handleRegister,
      contentPadding = _ref4.contentPadding;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_.TwoColumnMainMenu, {
    menuList: menuList,
    phoneNumber: phoneNumber,
    isRegistration: isRegistration,
    isLogin: isLogin,
    linkText: linkText,
    linkRoute: linkRoute,
    handleRegister: handleRegister
  }, cta), /*#__PURE__*/_react.default.createElement(MainContainer, {
    contentMaxWidth: contentMaxWidth,
    fillContent: fillContent,
    contentPadding: contentPadding
  }, /*#__PURE__*/_react.default.createElement(MainContent, {
    fillContent: fillContent
  }, render())));
};

TwoColumnMainContent.propTypes = {
  menuList: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  cta: _propTypes.default.node,
  handleRegister: _propTypes.default.func,
  render: _propTypes.default.func.isRequired,
  phoneNumber: _propTypes.default.string,
  isRegistration: _propTypes.default.bool,
  isLogin: _propTypes.default.bool,
  linkRoute: _propTypes.default.string,
  linkText: _propTypes.default.string,
  contentMaxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  fillContent: _propTypes.default.bool,
  contentPadding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
TwoColumnMainContent.defaultProps = {
  cta: null,
  phoneNumber: '1-888-819-6388',
  isRegistration: false,
  isLogin: false,
  handleRegister: function handleRegister() {},
  linkRoute: null,
  linkText: null,
  contentMaxWidth: 564,
  fillContent: false,
  contentPadding: 15
};
var _default = TwoColumnMainContent;
exports.default = _default;